import OrderRoColumnCheckboxSlot from '../orders/OrderRoColumnCheckboxSlot';
import OrderSelectAllHeaderCheckbox from '../orders/OrderSelectAllHeaderCheckbox';
import {
    DASHBOARD_FIRST_COLUMN_PL,
    DASHBOARD_RO_COLUMN_PL_CSS,
} from '../../constants/pageLayout';

export { DashboardRoColumnRow } from '../orders/orderRoColumnLayout';
export { handleOrderBulkRowClick } from '../../hooks/useOrderBulkSelection';

export interface DashboardBulkSelection {
    enabled: boolean;
    selectedOrderIds: Set<string>;
    onToggle: (orderId: string, rowIndex: number, shiftKey: boolean) => void;
    allPageSelected: boolean;
    isPageSelectionIndeterminate: boolean;
    onToggleSelectAll: () => void;
    pageOrderCount: number;
}

export const getDashboardRoColumnPl = (_bulkSelection?: DashboardBulkSelection) =>
    DASHBOARD_FIRST_COLUMN_PL;

export const getDashboardBulkTableSx = (
    bulkSelection?: DashboardBulkSelection,
    extraSx?: Record<string, unknown>,
) => ({
    ...extraSx,
    ...(bulkSelection?.enabled ? {
        '& tr:hover .order-row-checkbox': {
            opacity: '1 !important',
            pointerEvents: 'auto !important',
        },
        '& thead tr:hover .order-select-all-checkbox': {
            opacity: '1 !important',
            pointerEvents: 'auto !important',
        },
    } : {}),
});

/** Hover-reveal select-all in the Dashboard RO Number header gutter. */
export const DashboardRoSelectAllHeader = ({
    bulkSelection,
}: {
    bulkSelection?: DashboardBulkSelection;
}) => {
    if (!bulkSelection?.enabled) return null;
    return (
        <OrderSelectAllHeaderCheckbox
            contentPlWithBulk={DASHBOARD_RO_COLUMN_PL_CSS}
            allPageSelected={bulkSelection.allPageSelected}
            isPageSelectionIndeterminate={bulkSelection.isPageSelectionIndeterminate}
            onToggle={bulkSelection.onToggleSelectAll}
            isDisabled={bulkSelection.pageOrderCount === 0}
            ariaLabel="Select all orders on this page"
        />
    );
};

interface DashboardRoColumnCheckboxProps {
    orderId: string;
    rowIndex: number;
    isChecked: boolean;
    bulkSelection: DashboardBulkSelection;
}

export const DashboardRoColumnCheckbox = ({
    orderId,
    rowIndex,
    isChecked,
    bulkSelection,
}: DashboardRoColumnCheckboxProps) => (
    <OrderRoColumnCheckboxSlot
        orderId={orderId}
        rowIndex={rowIndex}
        isChecked={isChecked}
        onToggle={bulkSelection.onToggle}
    />
);

export const getDashboardRowHighlight = (isSelected: boolean, isReadOnly: boolean) => ({
    bg: isSelected ? 'blue.50' : 'white',
    _hover: {
        bg: isSelected ? 'blue.100' : 'gray.50',
        cursor: isReadOnly ? 'default' : 'pointer',
    },
});
